export default __webpack_public_path__ + "static/media/telegram-icon.cd802227.svg";